const STATUS_PRESENTATION = Object.freeze({
    want_to_read: Object.freeze({ status: 'want_to_read', label: 'Хочу прочитати', icon: null, token: 'want' }),
    reading: Object.freeze({ status: 'reading', label: 'Читаю', icon: 'book-open', token: 'reading' }),
    read: Object.freeze({ status: 'read', label: 'Прочитано', icon: 'check', token: 'completed' }),
    abandoned: Object.freeze({ status: 'abandoned', label: 'Не дочитано', icon: 'minus', token: 'abandoned' }),
});

const UNKNOWN_STATUS_PRESENTATION = Object.freeze({ status: 'unknown', label: 'Статус недоступний', icon: 'question-circle', token: 'unknown' });

function bookStatusPresentation(status) {
    return STATUS_PRESENTATION[status] || UNKNOWN_STATUS_PRESENTATION;
}

function isVisibleBookStatus(status) {
    return Object.prototype.hasOwnProperty.call(STATUS_PRESENTATION, status);
}

module.exports = { STATUS_PRESENTATION, bookStatusPresentation, isVisibleBookStatus };
